import { render } from "./ColorField.vue?vue&type=template&id=10faa4f1&scoped=true"
import script from "./ColorField.vue?vue&type=script&lang=js"
export * from "./ColorField.vue?vue&type=script&lang=js"

import "./ColorField.vue?vue&type=style&index=0&id=10faa4f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10faa4f1"]])

export default __exports__